<template>
  <div class="page-wrapper gray">
    <div class="container flex-cc flex-auto">
      <div class="shadow-wrapper login">
        <LoginForm v-bind="{handleLogin, loading}">
          <LoginHelper
            slot="footer"
            v-model="modal"
            login
          />
        </LoginForm>
        <div class="img-wrapper">
          <img 
            src="@/assets/log-in-login.jpg" 
            alt="磐石保經-線上投保-登入"
          >
          <h3 class="img-title">24H 隨時投保，給您全方位的守護，<br />貼心、安全、好操作，一同體驗。</h3>
        </div>
      </div>
    </div>
    <ForgotPasswordModal 
      v-model="modal"
      v-bind="{handleForgotReq, loading}"
    />
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import LoginForm from '@/components/forms/LoginForm';
  import ForgotPasswordModal from '@/components/modals/ForgotPasswordModal';
  import LoginHelper from '@/components/auth/login/LoginHelper';
  import { LOGIN_REQUEST_ACTION, FORGOT_PASSWORD_ACTION } from '@/store/modules/user/constants';

  export default {
    components: { LoginForm, ForgotPasswordModal, LoginHelper },
    data() {
      return {
        modal: false
      };
    },
    computed: {
      ...mapState({
        loading: ({ user }) => user.loading,
      })
    },
    methods: {
      ...mapActions([LOGIN_REQUEST_ACTION, FORGOT_PASSWORD_ACTION]),
      handleLogin(payload) {
        this.LOGIN_REQUEST_ACTION(payload);
      },
      handleForgotReq(payload) {
        return this.FORGOT_PASSWORD_ACTION(payload);
      }
    }
  };
</script>